import { API_FEEDBACK_REQUEST_PREFIX } from '@shared/config/api/api-prefixes';
import { feedbackRequestBaseApi } from './base';
import {
    FeedbackRequestDetailDataRequest,
    FeedbackRequestDetailDataResponse,
    FeedbackRequestListDataRequest,
    FeedbackRequestListDataResponse,
    FeedbackRequestStatusChangeDataRequest,
    FeedbackRequestStatusChangeDataResponse,
} from './feedback-request-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';

export const feedbackRequestApi = feedbackRequestBaseApi.injectEndpoints({
    endpoints: (build) => ({
        feedbackRequestsList: build.query<FeedbackRequestListDataResponse, FeedbackRequestListDataRequest>({
            query: (parameters) => `${API_FEEDBACK_REQUEST_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['FeedbackRequestsList'],
        }),
        feedbackRequestDetail: build.query<FeedbackRequestDetailDataResponse, FeedbackRequestDetailDataRequest>({
            query: (id) => `${API_FEEDBACK_REQUEST_PREFIX}/${id}/detail`,
            providesTags: (result) =>
                result ? [{ type: 'FeedbackRequestsDetail', id: result.id }] : ['FeedbackRequestsDetail'],
        }),
        feedbackRequestDownload: build.query<Blob, FeedbackRequestListDataRequest>({
            query: (parameters) => ({
                url: `${API_FEEDBACK_REQUEST_PREFIX}/export/xls${queryParametersToString({ ...parameters })}`,
                responseHandler: (response) => response.blob(),
            }),
        }),
        feedbackRequestChangeStatus: build.mutation<
            FeedbackRequestStatusChangeDataResponse,
            FeedbackRequestStatusChangeDataRequest
        >({
            query: (data) => {
                return {
                    url: `${API_FEEDBACK_REQUEST_PREFIX}/${data.id}/status`,
                    method: 'PATCH',
                    body: data,
                };
            },
            invalidatesTags: (result) => ['FeedbackRequestsList', { type: 'FeedbackRequestsDetail', id: result?.id }],
        }),
    }),
});

export const {
    useLazyFeedbackRequestsListQuery,
    useLazyFeedbackRequestDetailQuery,
    useLazyFeedbackRequestDownloadQuery,
    useFeedbackRequestChangeStatusMutation,
    usePrefetch: usePrefetchFeedbackRequest,
} = feedbackRequestApi;
